export function generateLinkSpreadsheet(dataOperation, formData, typeSurebet) {
  let gameCalculator = {market_mappings:[], time_event: new Date().toISOString(),  title: "", sub_title: "", operation_type: "Arbitragem"};
  for (let index = 0; index < dataOperation.length; index++) {
    let apostas = [];
    let markets = [];
    let betting  = dataOperation[index]
    let typeOdd = (betting["market_event"].replaceAll(" ", "").toLocaleLowerCase()).includes('lay(contra)') === true ? "lay" : "normal";
    let odd = String(betting["chance"]);
    let stake = String(betting.stake);
    let commission = String(betting.commission);
    let marketText = betting["market_event"];
    let infoMarketText = betting["info_market_event"];
    apostas.push({
      odd: odd,
      commission: commission,
      stake: stake,
      odd_type: typeOdd,
      bet_type: "normal",
    });
    markets.push({
        market_event: marketText,
        info_market_event: infoMarketText,
    })
    if(index === 0){
        try{
        gameCalculator["time_event"] = new Date(formData["time_expiration"]).toISOString();
        }catch{
            console.log("");
        }
        gameCalculator["title"] = formData["title"];
        gameCalculator["sub_title"] = formData["sub_title"];
        if(typeSurebet === "bonus_bookmaker"){
            apostas[0]["bet_type"] = "freebet";
            apostas[0]["bonus_value"] = stake;
        }
    }
    gameCalculator["market_mappings"].push(markets[0]);
    gameCalculator["market_mappings"][index]["positions"] = [apostas[0]];
  }
  let gameCalculatorJSON = JSON.stringify(gameCalculator);
  let partURL = encodeURIComponent(gameCalculatorJSON);
  let endpoint ="/planilha/apostas/nova?data=" + partURL;
  
  window.open(endpoint, '_blank', 'noopener,noreferrer');
}

